import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Home from './Home';
import Invite from './Invite';
import Login from './Login';
import Reset from './Reset';
import Signup from './Signup';
import Success from './Success';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#314f61',
    },
    secondary: {
      main: '#edca21',
    },
    background: {
      default: '#e9eff6',
    },
  },
});

let userState = {};
try {
  userState = JSON.parse(sessionStorage.getItem('user')) || {};
} catch (err) {}

const Basic = () => {
  const [user, setUser] = useState(userState);
  const setUserSession = (data) => {
    setUser(data);
    sessionStorage.setItem('user', JSON.stringify(data));
  };

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <CssBaseline />
        <Router>
          <Switch>
            <Route path="/signup/:product?">
              <Signup setUser={setUserSession} />
            </Route>
            <Route path="/invite">
              <Invite setUser={setUserSession} />
            </Route>
            <Route path="/reset">
              <Reset setUser={setUserSession} />
            </Route>
            <Route path="/success">
              <Success />
            </Route>
            <Route path="/">
              {user.email ? (
                <Home user={user} setUser={setUserSession} />
              ) : (
                <Login setUser={setUserSession} />
              )}
            </Route>
          </Switch>
        </Router>
      </Container>
    </ThemeProvider>
  );
};

export default Basic;
